let environment = {
    production: false,
    version: 'dev',
    scheme: 'light',
    notificationToken: 'CFlGX1b_6VivXzw',

    googleApiKey: 'AIzaSyCiMMYQFBB8n4kMmRqG5KVegf0WEGYrxNw',
    jsitelservletURL: 'https://jss.test.blue.puntosalud.ar/jsitelservlet/Do?',
    nuvalidFarmaciaURL: 'https://api.farmacia.dev.puntosalud.ar/api/v1/nuvalid-farmacia',
    nuvalidPuntoSalud: 'https://nvps.dev.blue.puntosalud.ar/api/v1/nuvalidpuntosalud',
    nuvalidLiteURL: 'https://mpos-dev.tx.puntosalud.ar/api/v1/mposbackend',
    nuvalidURL: 'https://nb-dev.tx.puntosalud.ar/api/v1/nuvalid',
    sitelrestURL:'https://tx.dev.blue.puntosalud.ar/sitelrest/v1/txs/xml',
    ticketURL: 'https://tickets.dev.blue.puntosalud.ar/api/v1/pstickets',
    surveyURL: 'http://localhost:8080',
    // ticketURL: 'https://tickets.itcsoluciones.ar/api/v1/pstickets',
    url: 'https://servicios.dev.blue.puntosalud.ar/pstool',
    // url: 'http://192.168.0.27:8080/pstool',
    // url: 'https://servicios.itcsoluciones.ar/pstool',
    aiURL: 'https://ia.dev.blue.puntosalud.ar',
    aiApiKey: 'app-YR4hEOXmKIVbZyr2DNKJp61a',
    // url: 'http://192.168.48.218:8080/pstool',
    // url: 'http://localhost:8080/pstool'
};

export { environment };
